import React, { useState, useEffect } from 'react';
import Slider from "react-slick";
import ProductCard from './ProductCard';
import { productosData } from '../data/productos';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
// Importamos los estilos de la librería por si acaso no estaban cargados globalmente
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import './ProductosDestacados.css'; // Asegurate que el nombre del archivo CSS sea este

// flechas de navegacion
const NextArrow = ({ onClick }) => (
  <div className="custom-arrow next-arrow" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="custom-arrow prev-arrow" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const FeaturedProducts = () => {
  // --- 1. ESTADOS PARA LOS DATOS REALES ---
  const [productosReales, setProductosReales] = useState([]);
  const [cargando, setCargando] = useState(true);

  // --- 2. LÓGICA DE RESPONSIVE (Intacta) ---
  const calcularSlides = () => {
    if (window.innerWidth <= 768) return 1; 
    if (window.innerWidth <= 1024) return 2; 
    return 3; 
  };

  const [slides, setSlides] = useState(calcularSlides());

  useEffect(() => {
    const manejarResize = () => setSlides(calcularSlides());
    window.addEventListener('resize', manejarResize);
    return () => window.removeEventListener('resize', manejarResize);
  }, []);

  // --- 3. FETCH A LA BASE DE DATOS ---
  useEffect(() => {
    const traerProductos = async () => {
      try {
        const respuesta = await fetch('https://api.pascolo.com.ar/api/web/catalogo');
        
        if (!respuesta.ok) throw new Error('Error al conectar con el servidor');
        
        const data = await respuesta.json();
        setProductosReales(data);
      } catch (error) {
        console.error("Error al traer los productos destacados:", error);
      } finally {
        // Pase lo que pase, apagamos el estado de carga
        setCargando(false);
      }
    };

    traerProductos();
  }, []);

  // --- 4. CONFIGURACIÓN DEL SLIDER ---
  const settings = {
    dots: false,
    infinite: productosReales.length > slides, // Evita bug si tenés menos quesos que el ancho de la pantalla
    speed: 500,
    slidesToShow: slides,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: slides > 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div style={{ padding: '4rem 1rem', backgroundColor: '#fdfbf7' }}>
      <h2 style={{ 
        textAlign: 'center', 
        fontFamily: 'Playfair Display', 
        color: '#2d5a27',
        fontSize: '2.5rem',
        marginBottom: '2rem'
      }}>
        Nuestros Quesos Destacados
      </h2>
      
      <div className="featured-carousel-wrapper">
        {/* Mostramos un texto de carga mientras viajan los datos */}
        {cargando ? (
          <p style={{ textAlign: 'center', color: '#555' }}>Cargando quesos...</p>
        ) : productosReales.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#555' }}>No hay quesos destacados por el momento.</p>
        ) : (
          <Slider {...settings}>
            {productosReales.map(producto => (
              <ProductCard key={producto.id} producto={producto} />
            ))}
          </Slider>
        )}
      </div>
    </div>
  );
};

export default FeaturedProducts;